const getUrlParameter = (search, name) => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  search = decodeURIComponent(search)

  let regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  let results = regex.exec(search)

  return results === null
    ? ''
    : decodeURIComponent(results[1].replace(/\+/g, ' '))
}

const toQueryString = (paramsObject) => {
  let queryString = Object.keys(paramsObject)
    .filter((key) => paramsObject[key].length > 0)
    .map(
      (key) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(paramsObject[key])}`
    )
    .join('&')

  if (queryString.length > 0) {
    return `?${queryString}`
  }

  return queryString
}

const updatePath = (navigate, locale, path, queryString) => {
  let strippedPath = path.replace(/^\//, '')
  let pathname = `/${locale}/${strippedPath}`

  navigate({
    pathname: pathname,
    search: queryString,
  })

  return navigate
}

const tidyQueryString = (url) => url.split('?').pop()

export { getUrlParameter, toQueryString, updatePath, tidyQueryString }
